import AuthService from 'src/services/api/auth.service';
import { useGetOnboardingUserInfoQuery } from 'src/store/api/onboarding';
import { useAppSelector } from 'src/store/redux';

export const useOnboardingUserInfo = () => {
  const userBk = AuthService.getUserBk();

  const hasOnboardingUserInfoError = useAppSelector(
    (state) =>
      state.onboarding.queries[`getOnboardingUserInfo("${userBk}")`]?.status ===
      'rejected',
  );

  return useGetOnboardingUserInfoQuery(userBk, {
    skip: !userBk || hasOnboardingUserInfoError,
  });
};
